import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProjectsService} from '../_services/projects.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SingleProjectModel} from '../_models/singleProject.model';

@Component({
    selector: 'app-task-edit',
    templateUrl: './task-edit.component.html',
    styleUrls: ['./task-edit.component.scss']
})
export class TaskEditComponent implements OnInit, OnDestroy {
    dataLoaded = false;

    projectId: string;
    stageId: string;
    taskId: string;
    isFromTasksModule = false;

    isTaskFromTable = false;

    responsibleStaff = [];
    gotStaff = false;

    taskData: any;
    userData: any;

    editTaskForm: FormGroup;
    subTasks = [];

    // Feedback Messages
    formResponse: boolean;
    formSent: boolean;
    successMsg = '';
    errorMsg = '';

    // Unsubscribe
    unsubscribe = [];

    constructor(private router: Router,
                private route: ActivatedRoute,
                private modalService: NgbModal,
                private projectsService: ProjectsService,
                private fb: FormBuilder) {
    }

    ngOnInit(): void {
        const routeSub = this.route.params.subscribe(params => {
            this.taskId = params.task;
            if (!params.id) {
                this.isFromTasksModule = true;
            }
            if (!params.position) {
                this.isTaskFromTable = true;
            }
        });
        this.unsubscribe.push(routeSub);

        this.projectsService.getTaskById(this.taskId).subscribe((task: any) => {
            
            this.taskData = task;
            this.subTasks = this.taskData.subtasks;
            this.stageId = task.projectStage.toString();
            this.projectId = task.projectId;

            if (this.projectId !== '' && this.projectId !== null) {
                this.projectsService.getProjectById(this.projectId).subscribe((project: SingleProjectModel) => {
                    
                    if (this.stageId !== '0') {
                        const stageData = project.stage[Number(this.stageId) - 1];
                        if (stageData && stageData.responsible.length > 0) {
                            const members = stageData.responsible;
                            members.forEach(member => {
                                this.responsibleStaff.push({
                                    responsibleId: member.responsibleId,
                                    responsibleName: member.responsibleName
                                });
                            });
                        }

                        const taskMemberIsStageMember = stageData.responsible
                            .some( member => member.responsibleId === this.taskData.receiverUserId);

                        if (!taskMemberIsStageMember) {
                            this.projectsService.getUserById(this.taskData.receiverUserId).subscribe((taskUser: any) => {
                                this.responsibleStaff.push({
                                    responsibleId: taskUser.id,
                                    responsibleName: taskUser.firstName + ' ' + taskUser.lastName
                                });
                                this.responsibleStaff.push({
                                    responsibleId: '',
                                    responsibleName: 'None'
                                });
                                this.gotStaff = true;
                            });
                        } else {
                            this.gotStaff = true;
                        }
                    } else {
                        if (project.staff.length > 0) {
                            project.staff.forEach(staffMember => {
                                this.projectsService.getUserById(staffMember).subscribe((user: any) => {
                                    this.responsibleStaff.push({
                                        responsibleId: user.id,
                                        responsibleName: user.firstName + ' ' + user.lastName
                                    });
                                });
                            });
                            
                            this.gotStaff = true;
                        } else {
                            this.responsibleStaff.push({
                                responsibleId: '',
                                responsibleName: 'None'
                            });

                            this.gotStaff = true;
                        }
                    }
                });
            } else {
                this.projectsService.getTeamMembers(true, false).subscribe((res: any) => {
                    res.forEach((teamMember: any) => {
                        this.responsibleStaff.push({
                            responsibleId: teamMember.id,
                            responsibleName: teamMember.firstName + ' ' + teamMember.lastName
                        });
                    });
                    this.gotStaff = true;
                });
            }

            this.projectsService.getUserById(this.taskData.receiverUserId).subscribe(user => {
                
                this.userData = user;
                this.loadTaskForm();

                this.dataLoaded = true;
            });
        });
    }

    loadTaskForm() {
        this.editTaskForm = this.fb.group({
            name: [this.taskData.messageTitle, Validators.required],
            description: [this.taskData.messageDetail],
            dueDate: [this.taskData.deadline.substr(0, 10), Validators.required],
            responsible: [this.taskData.receiverUserId]
        });
        
    }

    pushSubTask(taskValue) {
        this.subTasks.push({
            description: taskValue,
            solved: false
        });

        
    }

    removeSubTask(taskIndex) {
        this.subTasks.splice(taskIndex, 1);
        
    }

    submitTaskForm() {
        
        if (this.editTaskForm.valid) {
            

            const taskToSend = {
                messageTitle: this.editTaskForm.value.name,
                messageDetail: this.editTaskForm.value.description,
                receiverUserId: this.editTaskForm.value.responsible,
                deadline: this.editTaskForm.value.dueDate + 'T09:18:19.108Z',
                subtasks: this.subTasks,
                senderUserId: this.taskData.senderUserId,
                id: this.taskData.id,
                labelTask: this.taskData.labelTask,
                attachments: this.taskData.attachments,
                additionDate: this.taskData.additionDate,
                status: this.taskData.status,
                labelColour: this.taskData.labelColour,
                projectId: this.projectId,
                projectStage: this.stageId,
                taskMessages: this.taskData.taskMessages
            };

            this.projectsService.updateTaskERP(this.taskId, taskToSend).subscribe(res => {
                if (this.subTasks.length > 0) {
                    let subTasksSolved = 0;
                    let subTaskPercentage = 0;
                    this.subTasks.forEach(subTask => {
                        if (subTask.solved === true) {
                            subTasksSolved++;
                        }
                    });
                    subTaskPercentage = Math.floor(subTasksSolved * 100 / this.subTasks.length);
                    if (subTaskPercentage === 100) {
                        this.projectsService.changeTaskERPStatus(this.taskId, 'completed').subscribe(statusRes => {
                            
                        });
                    } else {
                        this.projectsService.changeTaskERPStatus(this.taskId, 'in progress').subscribe(statusRes => {
                            
                        });
                    }
                }
                if (this.stageId !== '0' && this.isTaskFromTable === false && this.isFromTasksModule === false) {
                    this.router.navigate([`/projects/${this.projectId}/stage/${this.stageId}/view/${this.taskId}/view`]);
                } else if (this.stageId !== '0' && this.isTaskFromTable === true && this.isFromTasksModule === false) {
                    this.router.navigate([`/projects/${this.projectId}/${this.taskId}/view`]);
                } else if (this.stageId === '0' && this.isFromTasksModule === false) {
                    this.router.navigate([`/projects/${this.projectId}/${this.taskId}/view`]);
                } else if (this.stageId === '0' && this.isFromTasksModule === true) {
                    this.router.navigate(['/tasks']);
                } else if (this.stageId === '0' && this.isFromTasksModule === true) {
                    this.router.navigate(['/tasks']);
                }
            });
        } else {
            this.scrollToTop();
            this.feedbackMsg('error', 'Please, fill out the required fields');
        }
    }

    // Scroll Top
    scrollToTop() {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }


    isControlInvalid(controlName: string): boolean {
        const control = this.editTaskForm.controls[controlName];
        return control.invalid && (control.dirty || control.touched);
    }


    controlHasError(validation: string, controlName: string) {
        const control = this.editTaskForm.controls[controlName];
        return control.hasError(validation) && (control.dirty || control.touched);
    }

    // FeedBack Msg
    feedbackMsg(type, message) {
        if (type === 'success') {
            this.formSent = true;
            this.formResponse = true;
            this.successMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);

        } else if (type === 'error') {
            this.formSent = true;
            this.formResponse = false;
            this.errorMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);
        }
    }

    ngOnDestroy() {
        this.unsubscribe.forEach(sb => sb.unsubscribe());
    }


}
